import { roomMeta, stayQuote, villa } from '../data';
import { formatLongDate, formatPrice, nightsBetween, nightsLabel, occupancyLabel } from '../utils';
import BookSteps from './BookSteps';
import { CheckIcon } from './Icons';

export default function ConfirmPage({ booking, onHome }) {
  const { guest, room, search, payment, code } = booking;
  const nights = nightsBetween(search.checkIn, search.checkOut) || 1;
  const meta = roomMeta(room);

  return (
    <div className="page page-book">
      <div className="wrap">
        <BookSteps current={2} />
        <div className="confirm-box">
          <div className="confirm-mark" aria-hidden="true">
            <CheckIcon />
          </div>
          <p className="hero-kicker">Reservation confirmed</p>
          <h1>{`Thank you, ${guest.first}.`}</h1>
          <p className="confirm-code">Confirmation {code}</p>
          <p className="confirm-lead">A copy will be sent to {guest.email}.</p>

          <div className="confirm-stay">
            <img src={room.images[0]} alt="" />
            <div>
              <p className="stay-bar-kicker">Your stay</p>
              <h2>{room.name}</h2>
              <p>{meta.beds} · Sleeps {meta.sleeps}</p>
            </div>
          </div>

          <dl className="confirm-facts">
            <div>
              <dt>Dates</dt>
              <dd>
                {formatLongDate(search.checkIn)} – {formatLongDate(search.checkOut)} · {nightsLabel(nights)}
              </dd>
            </div>
            <div>
              <dt>Guests</dt>
              <dd>{occupancyLabel(search.occupancy)}</dd>
            </div>
            <div>
              <dt>Arrival</dt>
              <dd>Estimated {guest.arrival} · Check-in from {villa.checkIn} · Check-out by {villa.checkOut}</dd>
            </div>
            <div>
              <dt>Guest</dt>
              <dd>{guest.first} {guest.last} · {guest.phone} · {guest.country}</dd>
            </div>
            {guest.notes?.trim() && (
              <div>
                <dt>Requests</dt>
                <dd>{guest.notes}</dd>
              </div>
            )}
            <div>
              <dt>Payment</dt>
              <dd>Pay at the villa · Card ending {payment.last4}</dd>
            </div>
            <div>
              <dt>Policy</dt>
              <dd>Free cancellation until 24 hours before arrival. Pay at the villa.</dd>
            </div>
            <div>
              <dt>Villa</dt>
              <dd>{villa.name} · {villa.address}</dd>
            </div>
          </dl>

          <div className="confirm-total">
            <span>Total</span>
            <strong className="price-now">{formatPrice(stayQuote(room, nights).total)}</strong>
          </div>
          <p className="price-note">Includes taxes and charges</p>
          <button className="see-btn book-submit" onClick={onHome}>Back to home</button>
        </div>
      </div>
    </div>
  );
}
